var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "boss-approach-info" }, [
    _c("table", { staticClass: "unstriped boss-table" }, [
      _c("thead", [
        _c("tr", [
          _c("th", { staticClass: "boss-table-head" }, [
            _vm._v("\n          アプローチした求人\n          "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: {
                      content:
                        "現在の掲載期間中に送信したスカウトは赤色で表示、それ以前に送信していた場合はグレーで表示されます。",
                    },
                    expression:
                      "{ content: '現在の掲載期間中に送信したスカウトは赤色で表示、それ以前に送信していた場合はグレーで表示されます。'}",
                  },
                ],
                staticClass: "pega-circle",
              },
              [_vm._v("?")]
            ),
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "boss-table-head" }, [
            _vm._v("\n          スカウト\n        "),
          ]),
          _vm._v(" "),
          _c("th", { staticClass: "boss-table-head" }, [
            _vm._v("\n          スカウト特典\n        "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.scouts_summaries, function (scoutsSummary, i) {
          return _c("tr", { key: i }, [
            _c(
              "td",
              {
                staticClass: "boss-table-data boss-ellipsis-block",
                attrs: {
                  "data-test": "management-name-" + scoutsSummary.job.id,
                },
              },
              [
                _vm._v(
                  "\n          求人ID: " +
                    _vm._s(scoutsSummary.job.id) +
                    " " +
                    _vm._s(scoutsSummary.job.managementName) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c("td", { staticClass: "boss-table-data" }, [
              _c("span", {
                staticClass: "boss-icon-ellipse",
                class: {
                  "pega-gray-color-important": !scoutsSummary.isScoutEffective,
                },
                attrs: { "data-test": "scout-ellipse-" + scoutsSummary.job.id },
              }),
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "boss-table-data" },
              _vm._l(scoutsSummary.specialFavors, function (specialFavor, j) {
                return _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: {
                          content: _vm.getSpecialFavorTooltip(specialFavor),
                        },
                        expression:
                          "{ content: getSpecialFavorTooltip(specialFavor)}",
                      },
                    ],
                    key: j,
                    staticClass: "boss-bonus-check-text boss-check-true",
                    class: { "boss-bonus-end": !specialFavor.isEffective },
                    attrs: {
                      "data-test":
                        "special-favor-" +
                        scoutsSummary.job.id +
                        "-" +
                        specialFavor.id,
                    },
                  },
                  [_vm._v(_vm._s(specialFavor.name))]
                )
              }),
              0
            ),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }